import {computed, reactive, ref, watchEffect} from 'vue';
import {cloneDeep} from 'lodash-es';
import {mySentry} from '@/monitor';
import {useLanguage} from '@front/hooks';
import {setVerifyHintingCloseCountStorageKey} from '@front/config';

const bootstrapData = ref({});

const ENUMS = computed(() => {
  const enumMap = cloneDeep(bootstrapData.value.applicationVariable?.enumMap);
  const { t, te, PREFIX } = useLanguage();
  Object.entries(enumMap).forEach(([name, list]) => {
    list.forEach(o => {
      o.value = o.name;
      if (name === 'ErrorCode') o.label = o.desc;
      else {
        const enumKey = `${name}.${o.name}`;
        o.label = te(enumKey, PREFIX.ENUMS) ? t(enumKey, PREFIX.ENUMS) : o.desc;
      }
    });
  });
  return enumMap;
});

const ENUM = computed(() => {
  const ret = {};
  Object.entries(ENUMS.value).forEach(([name, list = []]) => {
    ret[name] = {};
    list.forEach(o => {
      ret[name][o.name] = o.value;
    });
  });
  return ret;
});

const SELECTION = reactive({});

const agents = computed(() =>
  bootstrapData.value.agentPos?.map(o => {
    if (Object.prototype.hasOwnProperty.call(o, 'value')) {
      throw 'bootstrap agent SHOULD NOT have value';
    }
    return { ...o, label: o.name, value: o.id };
  }),
);

watchEffect(() => {
  const map = bootstrapData.value.applicationVariable?.enumMap || {};
  Object.entries(map).forEach(([name, list]) => {
    SELECTION[name] = {};
    list.forEach(o => {
      SELECTION[name][o.name] = o;
    });
  });
});

const userProfile = computed(() => bootstrapData.value.customerPo);

// const userAgent = computed(() => agents.value?.find(o => o.value === userProfile.value.agentId));
const userIt = computed(() => bootstrapData.value.it);
const token = computed(() => bootstrapData.value.token);
const verified = computed(() => userProfile.value.verified);
const shareUrl = computed(() => bootstrapData.value.shareUrl);
const env = computed(() => bootstrapData.value.env);
const verifyRequired = computed(() => bootstrapData.value.enableIDAuth ?? false);
const isGuest = computed(() => bootstrapData.value.guest ?? false);

function setBootstrapData(data) {
  bootstrapData.value = data;
  // data.customerPo.verified = false;
  // setToken(token.value);

  const { username, fullName, id, itId, agentId } = data.customerPo;
  setVerifyHintingCloseCountStorageKey(id);
  mySentry?.setUser({
    username,
    fullName,
    id,
    itId,
    agentId,
  });

  /*if (['LOCAL'].includes(import.meta.env.VITE_APP_ENV)) {
    checkFrontEnums(data.applicationVariable.enumMap);
    checkFrontI18n();
  }*/
}

export function useBootstrap() {
  return {
    setBootstrapData,
    ENUM,
    ENUMS,
    SELECTION,
    token,
    userProfile,
    agents,
    userIt,
    verified,
    shareUrl,
    env,
    verifyRequired,
    isGuest
  };
}
